import React from 'react';
import { Link } from 'react-router-dom';
import { Twitter, MapPin, Mail } from 'lucide-react';

export function Footer() {
  return (
    <footer className="bg-black text-white py-12 px-4">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        <div>
          <div className="mb-4">
            <span className="font-bold">CONVERTOLOGY</span>
          </div>
          <p className="text-gray-400">
            Create magnetic headlines that convert
          </p>
          <a 
            href="https://x.com/convertologist" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-gray-400 hover:text-white transition-colors mt-4"
          >
            <Twitter className="w-5 h-5" />
            <span>Follow us on X</span>
          </a>
        </div>

        <div>
          <h3 className="font-bold mb-4">Links</h3>
          <ul className="space-y-2 text-gray-400">
            <li><Link to="/about" className="hover:text-white">About</Link></li>
            <li><Link to="/privacy" className="hover:text-white">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-white">Terms of Service</Link></li>
            <li><Link to="/faq" className="hover:text-white">FAQ</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="font-bold mb-4">Contact Us</h3>
          <div className="text-gray-400 space-y-4">
            <div className="flex items-start gap-2">
              <MapPin className="w-5 h-5 flex-shrink-0 mt-1" />
              <address className="not-italic">
                <p>OmegaWalls OÜ</p>
                <p>Reg. №: 16473723</p>
                <p>Vesivärava tn 50-201</p>
                <p>Kesklinna linnaosa, Tallinn</p>
                <p>Harju maakond 10152</p>
                <p>Estonia</p>
              </address>
            </div>
            <div className="flex items-center gap-2">
              <Mail className="w-5 h-5 flex-shrink-0" />
              <a 
                href="mailto:convertology.ai@gmail.com"
                className="hover:text-white transition-colors"
              >
                convertology.ai@gmail.com
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-12 text-center text-gray-400">
        © 2024 CONVERTOLOGY. All Rights Reserved.
      </div>
    </footer>
  );
}